import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-package-create',
  templateUrl: './package-create.component.html',
  styleUrls: ['./package-create.component.less']
})
export class PackageCreateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
